import { slug } from '@chillibean/component-library/legacy';
import { Link } from 'react-router-dom';

import Button from '../../../../../../../primitives/form/button/Button';

function FormTemplateFooter(props) {
  const { saveButton, readOnly, formTemplateID } = props;
  const { handleFormAction, isDisable, showLoadingIcon, buttonTitle = '' } = saveButton;

  return (
    <div className="form-template-footer__container">
      <div className="form">
        <div className="cta__group cta__group--form">
          {readOnly && (
            <Link to={`/${formTemplateID}/versions`}>
              <Button name="BACK" buttonType="primary" elementType="button" />
            </Link>
          )}

          {!readOnly && (
            <>
              <Button
                name={buttonTitle}
                actionType="button"
                disable={isDisable}
                loadingIcon={showLoadingIcon}
                buttonType="primary"
                handleClick={() => {
                  handleFormAction();
                }}
                dataTestId={`${slug(buttonTitle)}-template-button`}
              />
              <Link to="/">
                <Button name="CANCEL" buttonType="light" elementType="button" />
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default FormTemplateFooter;
